"use strict";

exports.__esModule = true;
exports.style = exports.color = void 0;

var _is = require("./is");

var _expose = require("../styles/expose");

var types = ['primary', 'warning', 'danger', 'success', 'secondary'];
var attrs = ['background', 'color', 'border'];

function validateFormat(data) {
  if (!(0, _is.isObject)(data)) {
    console.error(new Error('Should enter a json data with attrs(key) and types(types)'));
    return false;
  } // attributes


  if (Object.keys(data).filter(function (v) {
    return attrs.indexOf(v) === -1;
  }).length > 0) {
    console.error(new Error("The attribute your entered does not exist need[" + attrs.join('/') + "]"));
    return false;
  } // types


  if (Object.values(data).filter(function (v) {
    return types.indexOf(v) === -1;
  }).length > 0) {
    console.error(new Error("The type your entered does not exist need[" + types.join('/') + "]"));
    return false;
  }

  return true;
}

function getClassname(data) {
  if (!validateFormat(data)) return '';
  return Object.keys(data).map(function (attr) {
    return (0, _expose.exposeClass)(data[attr] + "-" + attr);
  }).join(' ');
}

function getColor(type) {
  // insert to body make render
  var className = (0, _expose.exposeClass)("location-" + type);
  var div = document.createElement('div');
  div.className = className;
  document.body.appendChild(div); // get color

  var color = window.getComputedStyle(document.querySelector("." + className)).textDecorationColor;
  div.parentElement.removeChild(div);
  return color;
}

var color = {
  get primary() {
    return getColor('primary');
  },

  get warning() {
    return getColor('warning');
  },

  get danger() {
    return getColor('danger');
  },

  get success() {
    return getColor('success');
  },

  get secondary() {
    return getColor('secondary');
  }

};
exports.color = color;
var style = {
  getClassname: getClassname
};
exports.style = style;